import { Component, OnInit } from '@angular/core';
import {ConsultaService} from '../services/consulta.service';
import { ModalService } from '../services/modal.service';
import {InicioFaces} from '../interfaces/inicioFaces';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { AlertsService } from 'angular-alert-module';


@Component({
selector: 'app-consulta',
templateUrl: './consulta.component.html',
styleUrls: ['./consulta.component.css']
})
export class ConsultaComponent implements OnInit {

consulRepor: InicioFaces[];
consulta: any={};
caso : any = {};
respuestaFrom:FormGroup;
submitted = false;
respuesta: any ={};


API_ENDPOINT: string ='http://'+window.location.hostname+':3003';


constructor(private consultaService: ConsultaService,private httpClient: HttpClient,private formBuilder: FormBuilder, private alerts: AlertsService, private modalService: ModalService) { }

pdfSrc = ""; 

listarReportes() {
    console.log("whattt ahahahhah/*/*/*/*/*")
    this.consultaService.mostrarReporte().subscribe((data: any) => {
    this.consulRepor = data.obj;
    return;
    },
    (error) => {
    alert('Ocurrio un Error LISTAR REPORTES CANAL ETICA');
    console.log("imprimir", error);
    });
}


onVerCaso(data){
    // var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // this.consulta.login_id = currentUser.login_id;
    // console.log('aqui consulta',this.consulta);
  
    this.consultaService.consultReporte(data).subscribe((data: any) => {
          console.log('data servicio ooel',data);
  
          if (data.status === 200) {
            const url = this.API_ENDPOINT + '/' + data.obj.nombrePdf;
  
            window.open(url);
          } else {
            alert('DATOS INCORRECTOS PARA MOSTRAR REPORTE');
          }
          
        return false
      },
      (error) => {
          alert('Ocurrio un Error');
      });	
}


onResponder() {
    this.submitted = true;
    
    if (this.respuestaFrom.valid && !this.caso.respuesta) {
        
        this.consultaService.responder({respuesta: this.respuesta, caso_id : this.caso.caso_id}).subscribe((data) => {
            this.caso.respuesta =  this.respuesta.respuestaUsuario;
            this.modalService.open('custom-modal-5');
            this.clear();          
        });

    } else {
        this.modalService.open('custom-modal-6');
    }

}

openRespuesta(caso) {
    console.log("que pedo", caso);
        console.log("que pedo88", this.caso);

    this.caso= caso;
    
    this.modalService.open('custom-modal-4');
    this.respuesta.respuestaUsuario = caso.respuesta;
        
}


abrirAdjuntos(pdf: string){
    console.log('pddff',pdf);
    let url = this.API_ENDPOINT +"/" +pdf;
   
        // if(!url){
        //     this.modalService.open('custom-modal-7');
        // }else{
        window.open(url, "_blank");

        // }
      
    }

closeModal(id: string) {
    this.modalService.close(id);
}


clear() {
    this.respuesta = {};
    this.caso = null;
}

ngOnInit() {
this.listarReportes();
this.respuestaFrom = this.formBuilder.group({
    respuestaUsuario: ['', Validators.required],
   
});
}

}

